import { z } from "zod";

import {
  experienceStrategyDomainHashSchema,
  experienceStrategyDomainIdSchema,
  experienceStrategyPositiveRevisionSchema,
  type ExperienceStrategyVersion,
} from "@/features/experience-strategy/experienceStrategySchemas";

export const experienceStrategyAdjustmentReferenceSchema = z
  .object({
    schema: z.literal("experience_strategy_adjustment_ref.v1"),
    current_version_id: experienceStrategyDomainIdSchema,
    strategy_id: experienceStrategyDomainIdSchema,
    strategy_revision: experienceStrategyPositiveRevisionSchema,
  })
  .strict();

export const experienceStrategyProposalAdjustmentReferenceSchema = z
  .object({
    proposal_hash: experienceStrategyDomainHashSchema,
    proposal_id: experienceStrategyDomainIdSchema,
    proposal_revision: experienceStrategyPositiveRevisionSchema,
    schema: z.literal("experience_strategy_proposal_adjustment_ref.v1"),
  })
  .strict();

export type ExperienceStrategyAdjustmentReference = z.infer<
  typeof experienceStrategyAdjustmentReferenceSchema
>;
export type ExperienceStrategyProposalAdjustmentReference = z.infer<
  typeof experienceStrategyProposalAdjustmentReferenceSchema
>;

export type ExperienceStrategyChatAdjustmentReference =
  | ExperienceStrategyAdjustmentReference
  | ExperienceStrategyProposalAdjustmentReference;

export function parseExperienceStrategyChatAdjustmentReference(value: unknown) {
  const version = experienceStrategyAdjustmentReferenceSchema.safeParse(value);
  if (version.success) return version.data;
  const proposal =
    experienceStrategyProposalAdjustmentReferenceSchema.safeParse(value);
  return proposal.success ? proposal.data : null;
}

export function adjustmentReferenceForExperienceStrategyVersion(
  version: Pick<
    ExperienceStrategyVersion,
    "current_version_id" | "id" | "is_current" | "strategy_id" | "strategy_revision"
  >,
): ExperienceStrategyAdjustmentReference | null {
  if (!version.is_current || version.current_version_id !== version.id) {
    return null;
  }
  return {
    schema: "experience_strategy_adjustment_ref.v1",
    current_version_id: version.current_version_id,
    strategy_id: version.strategy_id,
    strategy_revision: version.strategy_revision,
  };
}

export function experienceStrategyAdjustmentPrompt(
  reference: ExperienceStrategyChatAdjustmentReference,
) {
  return reference.schema === "experience_strategy_adjustment_ref.v1"
    ? "请基于这条已确认的经验策略提出调整方案"
    : "请调整这份待确认的经验策略方案";
}
